//messages.js
export default {
    // RFQs
    rfq_id: "RFQ #",
    company_id: "Company",
    rfq_date: "Date Requested",
    reference_number: "Reference Number",
    status_id: "Status",
    billing_address_id: "Billing Address",
    shipping_address_id: "Shipping Address",
    comments: "Comments",
    edit_rfq: "Edit RFQ",
    add_rfq: "Add RFQ",
    delete_rfq: "Delete RFQ",
    delete_rfq_confirm: "This action is not reversible!",
    rfqs: "Request for Quote",

    rfq_detail_id: "ID",
    quantity: "Quantity",
    edit_rfq_request: "Edit RFQ",
    add_rfq_request: "Add RFQ",
    delete_rfq_request: "Delete RFQ",
    org_bill_location_label: "DOWA THT AMERICA, INC.",
    org_bill_address1: "2130 S. Woodland Cir",
    org_bill_address2: "",
    org_bill_city: "Bowling Green",
    org_bill_state: "Ohio",
    org_bill_zip_code: "43402",
    org_bill_country_iso_3: "United States",
    email_rfq: "Email RFQ",
    print_rfq: "Print RFQ",
    cost_price: "Cost Price",
    required_by_date: "Required By Date",
    expiration_date: "Expiration Date",
};
